module.exports = __webpack_public_path__ + "img/bg_route-map.24c4695a.jpg";